import { IMVADocumentResponse } from '@/context/data.types';
import api from './api';
import FileService from './fileService';

const { vendorServiceAPI, pimcoreServiceAPI } = api;

const GET_MVA_DOCUMENTS_PATH = "/vendorOnboarding/get-mva-documents";
const GET_MVA_TEMPLATE_CONTENT_PATH = `/asset/documentType/MVA_TEMPLATE/content`;

const MVADocumentService = {
  getMVADocuments: async (vendorId: string, assessmentId: string): Promise<IMVADocumentResponse | null> => {
    try {
      const resp = await vendorServiceAPI.get(`${GET_MVA_DOCUMENTS_PATH}/${vendorId}/assessment/${assessmentId}`);
      const apiData = resp.data;
      
      // Return the API response directly as it matches IMVADocumentResponse structure
      if (apiData) {
        return {
          vendorId: apiData?.vendorId,
          assessmentId: apiData?.assessmentId,
          mvaTemplateAvailable: apiData?.mvaTemplateAvailable,
          mvaLatest: apiData?.mvaLatest ? {
            id: apiData?.mvaLatest?.id,
            filename: apiData?.mvaLatest?.filename,
            fullpath: `https://download-url.com/mva/${apiData.mvaLatest.id}`, // Construct download URL
            modificationDate: apiData?.mvaLatest?.modificationDate,
          } : null,
          mvatjLatest: apiData?.mvatjLatest ? {
            id: apiData?.mvatjLatest?.id,
            filename: apiData?.mvatjLatest?.filename,
            modificationDate: apiData?.mvatjLatest?.modificationDate,
          } : null,
          mvaHistory: apiData?.mvaHistory,
          availableTransitions: apiData?.availableTransitions
        };
      }
      
      return null;
    } catch (error) {
      throw error;
    }
  },

  // Get MVA template content (Blob) from Pimcore service
  getMVATemplate: async (): Promise<Blob> => {
    try {
      const resp = await pimcoreServiceAPI.get(GET_MVA_TEMPLATE_CONTENT_PATH, { responseType: 'blob' });
      return resp.data;
    } catch (error) {
      throw error;
    }
  },

  // Download document by ID using FileService (same as compliance documents)
  downloadDocument: async (documentId: string | number, filename?: string): Promise<void> => {
    try {
      await FileService.downloadFile(documentId, filename);
    } catch (error) {
      console.error('Error downloading MVA document:', error);
      throw error;
    }
  },

  // Get document metadata by ID
  getDocumentMetadata: async (documentId: string | number): Promise<any> => {
    try {
      const resp = await vendorServiceAPI.get(`/asset/${documentId}`);
      return resp.data;
    } catch (error) {
      console.error('Error fetching document metadata:', error);
      throw error;
    }
  },
};

export default MVADocumentService;
